export enum FeatureTweekKeys {
    IsExpertInteractionTrackerEnabled = 'support/messaging_sales/is_expert_interaction_tracker_enabled',
    IsBetterEligibilityEnabled = 'support/messaging_sales/is_better_eligibility_enabled',
}
